import { useTranslation } from 'react-i18next';
import { Spin } from '../../Ant';
import SearchableSelect from '../../searchableSelect/searchableSelect';
import MatterRestrictionDialogs from './matterRestrictionDialogs';
import { useMatterSelect } from './useMatterSelect';

interface MatterSelectProps {
  disabled: boolean;
  transactionTypeInUse?: boolean;
  onOpenPicker: () => void;
  'aria-describedby'?: string;
}

/**
 * Its own component so the matter list is only fetched where the field is rendered. It renders the
 * trigger button directly, which the form's focus helpers rely on.
 */
const MatterSelect = ({
  disabled,
  transactionTypeInUse,
  onOpenPicker,
  'aria-describedby': ariaDescribedBy,
}: Readonly<MatterSelectProps>) => {
  const { t } = useTranslation();
  const { select, dialogs, isCheckingRestrictions } = useMatterSelect({ transactionTypeInUse });

  return (
    <>
      <SearchableSelect
        {...select}
        disabled={disabled}
        ariaLabel={t('matter:matter')}
        placeholder={t('matter:selectMatter')}
        searchPlaceholder={t('matter:search')}
        onSearchIconClick={onOpenPicker}
        aria-describedby={ariaDescribedBy}
        data-field="matter"
        data-testid="select-matter-button"
      />
      <MatterRestrictionDialogs {...dialogs} />
      {isCheckingRestrictions && <Spin fullscreen />}
    </>
  );
};

export default MatterSelect;
